import { render, staticRenderFns } from "./SidebarAdmin.vue?vue&type=template&id=9949a444&"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js&"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAdmin.vue?vue&type=style&index=0&id=9949a444&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports